import { useState, useEffect } from 'react';
import { Box, Paper, Typography, Button, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { analytics } from '../../services/analytics';

export const CookieConsentBanner = () => {
  const { t } = useTranslation('cookieConsent');
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('ga_consent');
    if (consent === null) {
      setShowBanner(true);
    } else if (consent === 'true') {
      analytics.initialize();
    }
  }, []);

  const handleAccept = () => {
    analytics.setConsent(true);
    setShowBanner(false);
  };

  const handleDecline = () => {
    analytics.setConsent(false);
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        color: 'white',
        p: { xs: 2, sm: 3 },
        borderRadius: 0,
      }}
    >
      <Box
        sx={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'flex-start', md: 'center' },
          gap: { xs: 2, md: 3 },
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
            {t('title')}
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            {t('message')}{' '}
            <Link
              href="/privacy-policy"
              sx={{
                color: 'primary.light',
                textDecoration: 'underline',
                '&:hover': {
                  color: 'primary.main',
                },
              }}
            >
              {t('privacy_link')}
            </Link>
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            gap: 2,
            flexShrink: 0,
            width: { xs: '100%', md: 'auto' },
          }}
        >
          <Button
            variant="outlined"
            onClick={handleDecline}
            sx={{
              flex: { xs: 1, md: 'none' },
              color: 'white',
              borderColor: 'rgba(255, 255, 255, 0.5)',
              '&:hover': {
                borderColor: 'white',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            {t('decline')}
          </Button>
          <Button
            variant="contained"
            onClick={handleAccept}
            sx={{
              flex: { xs: 1, md: 'none' },
              backgroundColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            }}
          >
            {t('accept')}
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};
